import React, { Component } from "react";

class LoadingSpinner extends Component {
  render() {
    return <div className="lds-dual-ring" />;
  }
}

export default LoadingSpinner;
